<template>
    <div>
        <el-collapse>
            <el-collapse-item>
                <template slot="title">
                    <i class="header-icon el-icon-s-operation"></i>筛选
                    <span class="totalwrp">总条数:{{ total }}</span>
                </template>
                <div class="dataFilterWrap">
                    <el-row :gutter="10">
                        <el-col :span="5">
                            <el-input type="text" v-model="keyword" placeholder="输入关键字"></el-input>
                            <el-button type="success" round icon="el-icon-search" @click="searchKeyWord">筛选</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-collapse-item>
        </el-collapse>

        <el-table :data="agencyList" stripe fit tooltip-effect="dark">
            <el-table-column label="序号" width="100">
                <template slot-scope="scope">{{ scope.row._rowNumber }}</template>
            </el-table-column>
            <el-table-column label="姓名" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.InsurancePerson_Name }}</template>
            </el-table-column>
            <el-table-column label="身份证" show-overflow-tooltip width="210">
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_CertNo }}</template>
            </el-table-column>
            <el-table-column label="原姓名" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_OldName }}</template>
            </el-table-column>
            <el-table-column label="原身份证" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_OldCertNo }}</template>
            </el-table-column>
            <el-table-column label="更替时间" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_ReplaceTime }}</template>
            </el-table-column>
            <!-- <el-table-column label="企业名称" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.TravelCompany_Name }}</template>
            </el-table-column> -->
            <el-table-column label="责任险金额" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_LiabilityMoney }}</template>
            </el-table-column>
            <el-table-column label="状态" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_Delete == 0 ? '已生效' : '已中止' }}</template>
            </el-table-column>
            <el-table-column label="属组" show-overflow-tooltip width="110">
                <template slot-scope="scope"> {{ scope.row.InsurancePerson_PolicyName }}</template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper" :total="total" @current-change="setPageIndx">
        </el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            changeName: "",
            changeCertNo: "",
            agencyList: [],
            szTable: [],
            ctraTable: [],
            products: "",
            isdelete: "",
            keyword: "",
            starttime: "",
            endtime: "",
            currenttime: "",
            pageindex: 1,
            pagesize: 10,
            total: 0,
            companyid: 0,
            currentPerson: "",
            refundtime: "",
            showRefundDialog: false,
            showChangeView: false,
            userInfo: JSON.parse(sessionStorage.getItem("userInfo"))
        }
    },

    mounted() {
        this.pullList()
        this.getSuzu()
        this.getCtraList()
    },
    methods: {
        showChange(item) {
            this.currentPerson = item
            this.changeName = ""
            this.changeCertNo = ""
            this.showChangeView = true
        },
        sureToChange() {
            if (this.changeName == "" || this.changeCertNo == "") {
                this.$message.error("请填写完整信息")
                return
            }
            this.ipost("/AdminTravel/InsuranceWelfarePerson.ashx?type=replace", {
                id: this.currentPerson.InsurancePerson_ID,
                name: this.changeName,
                certno: this.changeCertNo
            }, (res) => {
                this.$message.success("修改成功")
                this.showChangeView = false
                this.pullList()
            })
        },
        getSuzu() {
            this.ipost("/AdminTravel/PolicyWelfare.ashx?type=select", null, (res) => {
                this.szTable = res.list
            })
        },
        ctraName(id) {
            var name = ""
            this.ctraTable.forEach(item => {
                if (item.Insurance_ID == id) {
                    name = item.Insurance_Destination
                }
            })
            return name
        },
        getCtraList() {
            this.ipost("/AdminTravel/InsuranceWelfare.ashx?type=select", null, res => {
                this.ctraTable = res.list
            })
        },
        pullList() {
            this.ipost(
                "/AdminTravel/InsuranceWelfarePerson.ashx?type=selectreplace", {
                keyword: this.keyword,
                isdelete: this.isdelete,
                pageindex: this.pageindex,
                pagesize: this.pagesize,
            },
                (res) => {
                    // console.log("res:", res)
                    this.agencyList = res.list.map(item => {
                        // 是否超过一个月
                        item.overMonth = Date.now() - (Date.parse(item.InsurancePerson_EffectTime) + 30 * 24 * 60 * 60 * 1000) > 0
                        return item
                    })
                    this.total = res.count
                }
            );
        },

        showRefund(item) {
            this.currentPerson = item
            this.showRefundDialog = true
        },
        showDelete(item) {
            this.$confirm("确定要删除吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.ipost(
                    "/AdminTravel/InsuranceWelfarePerson.ashx?type=delete", {
                    id: item.InsurancePerson_ID,
                },
                    (res) => {
                        this.pullList()
                    }
                )
            })
        },
        sureSendRefund() {
            this.ipost(
                "/AdminTravel/insuranceWelfarePerson.ashx?type=refund", {
                id: this.currentPerson.InsurancePerson_ID,
                refundtime: this.refundtime,
            },
                (res) => {
                    this.refundtime = ""
                    this.showRefundDialog = false
                    this.pullList()
                    this.$message({
                        message: "退保成功",
                        type: "success",
                    });
                }
            );
        },
        checkPerson() {
            this.ipost(
                "/AdminTravel/InsuranceWelfarePerson.ashx?type=select", {
                starttime: this.starttime,
                endtime: this.endtime,
            },
                (res) => {
                    // console.log("res:", res)
                    this.agencyList = res.list.map(item => {
                        // 是否超过一个月
                        item.overMonth = Date.now() - (Date.parse(item.InsurancePerson_EffectTime) + 30 * 24 * 60 * 60 * 1000) > 0
                        return item
                    })
                    this.total = res.count
                }
            );
        },
        exportPerson() {
            this.ipost(
                "/AdminTravel/insuranceWelfarePerson.ashx?type=exporttoexcel", {
                starttime: this.starttime,
                endtime: this.endtime,
            },
                (res) => {
                    window.open(this.domin + res.url);
                }
            );
        },
        checkPersonEx() {
            this.ipost(
                "/AdminTravel/InsuranceWelfarePerson.ashx?type=select", {
                operatetime: this.currenttime,
            },
                (res) => {
                    // console.log("res:", res)
                    this.agencyList = res.list.map(item => {
                        // 是否超过一个月
                        item.overMonth = Date.now() - (Date.parse(item.InsurancePerson_EffectTime) + 30 * 24 * 60 * 60 * 1000) > 0
                        return item
                    })
                    this.total = res.count
                }
            );
        },
        exportPersonEx() {
            this.ipost(
                "/AdminTravel/InsuranceWelfarePerson.ashx?type=exporttoexcelbyoperatetime", {
                operatetime: this.currenttime,
            },
                (res) => {
                    window.open(this.domin + res.url);
                }
            );
        },
        setPageIndx(pgindx) {
            this.pageindex = pgindx;
            this.pullList();
        },
        searchKeyWord() {
            this.pageindex = 1;
            this.pullList();
        },
        showPrint(item) {
            let pageCont = `

<head>
	<meta http-equiv="content-type" content="text/html; charset=utf-8" />
	<title>打印</title>
	<meta name="generator" content="LibreOffice 24.8.1.2 (Linux)" />
	<meta name="author" content="ASUS" />
	<meta name="created" content="2025-06-27T01:58:00" />
	<meta name="changedby" content="大山" />
	<meta name="changed" content="2025-06-27T05:46:38" />
	<meta name="CRO" content="wqlLaW5nc29mdCBQREYgdG8gV1BTIDExMA" />
	<meta name="ICV" content="76EEBFA6423245778F096636284CCF32_13" />
	<meta name="KSOProductBuildVer" content="2052-12.1.0.21541" />
	<meta name="KSOTemplateDocerSaveRecord"
		content="eyJoZGlkIjoiY2QzOGVlMzFlZWQ3N2RiN2NmYThmNDZhOWZiNjU4ODYiLCJ1c2VySWQiOiI1NTY3MjY4OTkifQ==" />
	<style type="text/css">
		@page {
			size: 8.27in 11.69in;
			margin-left: 0.78in;
			margin-right: 0.62in;
			margin-bottom: 0.19in
		}

		p {
			color: #000000;
			line-height: 100%;
			text-align: left;
			orphans: 2;
			widows: 2;
			margin-bottom: 0in;
			direction: ltr;
			background: transparent
		}

		p.western {
			font-family: "微软雅黑";
			font-size: 9pt;
			so-language: en-US
		}

		p.cjk {
			font-family: "微软雅黑";
			font-size: 9pt;
			so-language: en-US
		}

		p.ctl {
			font-family: "微软雅黑";
			font-size: 9pt;
			so-language: ar-SA
		}
	</style>
</head>

<body lang="en-US" text="#000000" link="#000080" vlink="#800000" dir="ltr">
    <div style="width:800px;margin:0 auto;">
	<div title="header">
		<p class="western" align="center" style="line-height: 5%">
			<br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%"><br />

		</p>
		<p class="western" align="center" style="line-height: 5%; margin-bottom: 0.89in;text-align: center;">
			
		</p>
	</div>
	<p class="western" align="center" style="line-height: 150%; margin-top: 0.24in;text-align: center;display:flex;align-items: center;justify-content: center;">
		<font face="微软雅黑">
			<img style="display:inline-block;margin-right:20px" src="data:image/jpeg;base64,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"
				name="IM 2" align="bottom" width="150" height="50" border="0" />
			<span style="letter-spacing: -0.1pt;font-size:22px;position: relative;bottom:20px">
				<font size="4" style="font-size: 16pt"><span lang="zh-CN">家政保</span></font>
			</span><span style="letter-spacing: -0.1pt;font-size:22px;position: relative;bottom:20px">
				<font size="4" style="font-size: 16pt">投保确认书</font>
			</span></font>
	</p>
	<p class="western" style="line-height: 150%; margin-left: 0.19in; margin-top: 0.19in">
		<font face="微软雅黑"><span style="letter-spacing: -0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">尊敬的客⼾</font>
				</font>
			</span><span style="letter-spacing: 1.7pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">
					</font>
				</font>
			</span></font>
		<font face="仿宋">
			<font size="3" style="font-size: 12pt"><span style="letter-spacing: -0.2pt">:</span></font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in; margin-left: 0.19in; margin-top: 0.06in">
		<font face="微软雅黑"><span style="letter-spacing: 0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">您在本公司</font>
				</font>
			</span><span style="letter-spacing: 0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt"><span lang="zh-CN">提交的</span></font>
				</font>
			</span><span style="letter-spacing: 0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">投保件</font>
				</font>
			</span><span style="letter-spacing: 0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt"><span lang="zh-CN">，</span></font>
				</font>
			</span><span style="letter-spacing: 0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">本公司已完成承保⼿续。</font>
				</font>
			</span><span style="letter-spacing: 0.2pt">
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">现将本公司承保的具体情况通知如下：</font>
				</font>
			</span></font>
	</p>
	<ol>
		<li class="western" style="line-height: 150%; margin-top: 0.06in"> 
			<p class="western" style="line-height: 150%; margin-top: 0.06in">
				<font face="微软雅黑"><span style="letter-spacing: 0.2pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt">投保单位：${item.TravelCompany_Name || 'XX投保单位'}</font>
						</font>
					</span><span style="letter-spacing: 0.2pt">
</span>
				</font>
			</p>
		</li>
		<li>
			<p class="western" style="line-height: 150%; margin-top: 0.06in">
				<font face="微软雅黑"><span style="letter-spacing: 0.2pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">被保险人</span></font>
						</font>
					</span><span style="letter-spacing: 0.2pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt">：</font>
						</font>
					</span><span style="letter-spacing: 0.2pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">${item.InsurancePerson_Name}</span></font>
						</font>
					</span></font>
				<font face="仿宋">
					<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.2pt"><span
								lang="en-US"> </span></font>
				</font>
				<font face="微软雅黑">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">${item.InsurancePerson_CertNo}</span></font>
					</font>
				</font></span>
			</p>
		</li>
		<li>
			<p class="western" style="line-height: 150%; margin-top: 0.06in">
				<font face="微软雅黑"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt">保险期限：
							</font>
						</font>
				</font>
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">${item.InsurancePerson_EffectTime}</font>
				</font>
				<font face="微软雅黑">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt">起
							⾄ </font>
					</font>
				</font>
				<font face="仿宋">
					<font size="3" style="font-size: 12pt">${item.InsurancePerson_RefundTime}</font>
				</font></span>
			</p>
		</li>
	
		<li>
			<p class="western" style="line-height: 150%; margin-top: 0in">
				<font face="微软雅黑">
					<font color="#000000"><span style="letter-spacing: 0.1pt">
							<font face="仿宋">
								<font size="3" style="font-size: 12pt"><span
										lang="zh-CN">本保险由中国人寿保险股份有限公司温州分公司和中国人寿财产保险股份有限公司温州中心支公司联合承保。</span></font>
							</font>
						</span></font>
				</font>
			</p>
		</li>
		<li>
			<p class="western" style="line-height: 150%; margin-top: 0in"><span style="letter-spacing: -1.1pt">
				</span>
				<font face="微软雅黑"><span style="letter-spacing: -1.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">保险套餐:</span></font>
						</font>
					</span>
				</font>
				${item.Policy_Brief || '版本名称'}
			</p>
		</li>
		<li>
			<p class="western" style="line-height: 150%; margin-top: 0in">
				<font face="微软雅黑">
					<font color="#000000"><span style="letter-spacing: 0.1pt">
							<font face="仿宋">
								<font size="3" style="font-size: 12pt"><span lang="zh-CN">家政保保障</span></font>
							</font>
						</span></font>
					<font color="#000000"><span style="letter-spacing: 0.1pt">
							<font face="仿宋">
								<font size="3" style="font-size: 12pt"><span lang="en-US">方案</span></font>
							</font>
						</span></font>
				</font>
			</p>
		</li>
	</ol>

	<p class="western" style="line-height: 150%; text-indent: 0.44in">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 11pt">${item.Policy_Brief || '版本名称'}
							</font>
						</font>
					</span></font>
			</font>
		</font>
	</p>

	<p class="western" style="line-height: 150%; text-indent: 0.44in">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<p size="3" style="font-size: 11pt; padding-left:51px">${item.Policy_Term && item.Policy_Term || '版本描述'}
							</p>
						</font>
					</span></font>
			</font>
		</font>
	</p>

	<p class="western" style="letter-spacing: 0.1pt; line-height: 150%; text-indent: 0.34in">
		<br />
	</p>

	<p class="western" style="line-height: 150%">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">七、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">保</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">险责任详细</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">内容</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%"><a name="_GoBack"></a>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">（一）</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN"><b>家政服务人员保障部分</b></span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">1</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">意外身故保险金</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">被保险人遭受意外伤害，并自该意外伤害发生之日起一百八十日内因该意外伤害导致身故的，给付意外伤害身故保险金，以保额为限。</span>
							</font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">2</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">意外伤残保险金</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" align="left"
		style="line-height: 150%; page-break-inside: auto; orphans: 2; widows: 2; text-indent: 0.34in; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">1</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">被保险人遭受意外伤害，并自该意外伤害发生之日起一百八十日内因该意外伤害导致身体伤残的，</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">本公司依据《工伤及职业病致残程度鉴定标准</span></font>
					</span></font>
			</font></span>
		</font>
		</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">GB/T16180-2014</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">》确定伤残等级，及其对应的保险金给付比例：一级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">100%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，二级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">75%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，三级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">50%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，四级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">30%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，五级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">20%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，六级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">15%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，线级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">10%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，八级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">7%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，九级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">5%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，十级</span></font>
					</font>
				</font>
			</font>
			<font face="Arial, sans-serif">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="en-US">1%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">，按保险合同约定的该被保险人的意外伤残保险金额乘以该处伤残的伤残等级所对应的保险金给付比例给付意外伤残保险金。</span></font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">2</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">对每一被保险人给付的意外伤残保险金以保险合同约定的该被保险人的意外伤残保险金额为限。</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">3</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、猝死</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">保险金</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">被保险人</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">在工作期间因突发</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">急性病，并自该急性病发生之日起</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">72</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">小时</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">内因该急性病导致身故的，按保险合同约定的该被保险人的</span>
							</font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">猝死</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">保险金额给付</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">猝死</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">保险金</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">，突发疾病不包含既往疾病</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">。</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">4</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">意外医疗保险金</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">1</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">被保险人在中国境内遭受意外伤害，并因该意外伤害在二级以上（含二级）医院或甲方认可的其他医疗机构诊疗的，对该被保险人每次意外伤害事故所发生并实际支出的符合当地社会基本医疗保险支付范围的医疗费用，在扣除当地社会基本医疗保险、公费医疗、城乡居民大病保险、其他费用补偿型医疗保险和其他途径已经补偿或给付部分后，</span>
							</font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">免赔额为</span></font>
					</span></font>
			</font></span>
		</font>
		</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">，</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">对其余额按</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">100%</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">的</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">给付比例给付意外医疗保险金。</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" align="left"
		style="line-height: 150%; page-break-inside: auto; orphans: 2; widows: 2; text-indent: 0.34in; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">2</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">保险期间届满被保险人治疗仍未结束的，甲方继续承担意外医疗保险</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">金</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">责任</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">，</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">因意外伤害事故发生的诊疗以保险期间届满的次日起一百八十日为限。</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">3</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">本公司对每一被保险人所承担的意外医疗保险金给付责任以本合同约定的该被保险人的意外医疗保险金额为限。</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">5</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">意外伤害住院定额给付保险金</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">在保险合同保险期间内，被保险人患遭受意外伤害，并因该意外伤害在二级以上（含二级）医院或甲方认可的其他医疗机构治疗的，按本合同约定的该被保险人的意外伤害住院日定额给付保险金额乘以给付日数给付意外伤害住院定额给付保险金</span>
							</font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">，单次同一原因住院最多补助天数以</span></font>
					</span></font>
			</font></span>
		</font>
		</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">90</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">天为限。</span></font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">家政人员因为工作原因意外受伤导致无法正常工作，持有医院出具的</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">病休建议单</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">证明向保险公司索赔误工</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">补贴</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">，</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">单次最多补助天数以</span></font>
					</span></font>
			</font></span>
		</font>
		</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">90</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">天为限，申请误工补贴时，如已获得意外伤害住院补贴金的相应天数予以扣除。</span></font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western" style="line-height: 150%; text-indent: 0.34in">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span lang="en-US">
								</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN"><b>（二）</b></span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN"><b>雇主及其家庭成员（含第三者）</b></span>
							</font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN"><b>保障部分</b></span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">1</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">在保险期间内，被保险人在本保险合同载明的区域范围内从事本保险合同载明的家政服务内容时，因一般过失造成第三者（含接受家政服务的对象）的人身伤亡或财产损失，依照中华人民共和国法律（不包括港澳台地区法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同约定负责赔偿。</span>
							</font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">（</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">家政服务：是指依法从事家政服务工作的人员以家庭为服务对象，进入家庭成员住所提供的烹饪、保洁、搬家、家庭教育、儿童看护以及孕产妇、婴幼儿、老人和病人的护理等有偿服务。</span>
							</font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">2</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">、金银、珠宝、钻石、玉器、首饰、现钞、有价证券、票据、文件、账册、技术资料、图纸、各种收藏品、家禽、家畜、花、树、鸟、盆景，以及其他无法鉴定价格的财产的损失保险人不负责赔偿；</span>
						</font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">3</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、知道保险事故发生后，被保险人应该：</span></font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">1</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">）及时通知保险人，并书面说明事故发生的原因、经过和损失情况；故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担赔偿责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外；</span>
						</font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">2</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">）保护事故现场，允许并且协助保险人进行事故调查；对于拒绝或者妨碍保险人进行事故调查导致无法认定事故原因或核实损失情况的，保险人对无法确定或核实的部分不承担赔偿责任</span>
						</font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">4</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">、被保险人收到第三者的损害赔偿请求时，应立即通知保险人。未经保险人书面同意，被保险人对第三者作出的任何承诺、拒绝、出价、约定、付款或赔偿，保险人不受其约束。对于被保险人自行承诺或支付的赔偿金额，保险人有权重新核定，不属于本保险责任范围或超出应赔偿限额的，保险人不承担赔偿责任。在处理索赔过程中，保险人有权自行处理由其承担最终赔偿责任的任何索赔案件，被保险人有义务向保险人提供其所能提供的资料和协助。</span>
						</font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">5</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">、被保险人请求赔偿时，投保人、被保险人应向保险人提供投保人、被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料：二级以上（含二级）医疗机构或公安机关出具的死亡证明、户口注销证明，二级以上（含二级）医疗机构或司法鉴定机构出具的残疾鉴定诊断书、二级以上（含二级）医疗机构或保险人认可的其他医疗机构出具的医疗费用收据、就诊病例、住院病历、检查报告、用药清单。</span>
						</font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">6</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span
								lang="zh-CN">、医疗费用赔偿范围仅限符合当地社会基本医疗保险支付范围内的医疗费用，在扣除当地社会基本医疗保险、公费医疗、城乡居民大病保险、其他费用补偿型医疗保险和其他途径已经补偿或给付部分后，免赔额为0，对其余额按100%的给付比例赔付。</span>
						</font>
					</font>
				</font>
			</font></span>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">7</span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span
									lang="en-US">人体损伤致残程度分级内容：永久丧失全部工作能力或一级伤残</span></font>
					</span></font>
			</font></span>
		</font>
		</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">100%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">二级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">90</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">三级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">8</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">四级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">7</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">五级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">6</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">六级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">50</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">七级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">4</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">八级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">3</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">九级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">2</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">0%</span></span></font>
					</font>
				</font>
			</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">、</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">十级伤残</span></font>
						</font>
					</span></font>
			</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">10</span></span></font>
					</font>
				</font>
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">%</span></font></span></span>
					</font>
				</font>
			</font>
		</font>
		</font>
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">。</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">（</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">评定机构：具有法医临床鉴定资质的司法鉴定机构</span>
							</font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">）</span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US"><span style="font-weight: normal">8</span></span></font>
					</font>
				</font>
			</font>
			<font face="Arial">
				<font size="2" style="font-size: 10pt">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span lang="zh-CN"><span
									style="font-weight: normal">、对家政服务人员工作过失导致</span></span></font>
					</font></span>
				</font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN"><span
										style="font-weight: normal">雇主及其家庭成员（含其他第三者）意外受伤所产生的</span></span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="text-decoration: none">
						<font face="仿宋">
							<font size="2" style="font-size: 11pt"><span lang="zh-CN"><span
										style="font-style: normal"><span
											style="font-weight: normal">医疗费用及财产损失部分不设免赔</span></span></span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN"><span
										style="font-weight: normal">。</span></span></font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">八</span></font>
						</font>
					</span></font>
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="en-US">、全国统—客⼾服务电话：</span></font>
					</span></font>
			</font></span>
		</font>
		</font>
		</font>
		<font face="Arial, sans-serif">
			<font size="2" style="font-size: 10pt">
				<font color="#000000">
					<font face="仿宋">
						<font size="3" style="font-size: 12pt"><span style="letter-spacing: 0.1pt"><span
									lang="en-US">95519</span></span></font>
					</font>
				</font>
			</font>
		</font>
	</p>
	<p class="western"
		style="line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<font face="Arial">
			<font size="2" style="font-size: 10pt">
				<font color="#000000"><span style="letter-spacing: 0.1pt">
						<font face="仿宋">
							<font size="3" style="font-size: 12pt"><span lang="zh-CN">九、以上说明未尽之处，以保险条款为准!</span>
							</font>
						</font>
					</span></font>
			</font>
		</font>
	</p>
	<p class="western"
		style="letter-spacing: 0.1pt; line-height: 150%; page-break-inside: auto; orphans: 0; widows: 0; text-indent: 0.34in; page-break-before: auto; page-break-after: auto">
		<br />

	</p>

	<p>
		附录:短期费率表 </p>
		<br />
	<table cellpadding="1" cellspacing="0" borderwidth="0"  border="1" style="width: 720px;margin: 10px auto;text-align: center;">
		<tbody>
			<tr>
				<td style="padding: 0.08in;">
					保险期间
				</td>
				<td style="padding: 0.08in;">
					一个月
				</td>
				<td style="padding: 0.08in;">
					二个月
				</td>
				<td style="padding: 0.08in;">
					三个月
				</td>
				<td style="padding: 0.08in;">
					四个月
				</td>
				<td style="padding: 0.08in;">
					五个月
				</td>
				<td style="padding: 0.08in;">
					六个月
				</td>
				<td style="padding: 0.08in;">
					七个月
				</td>
				<td style="padding: 0.08in;">
					八个月
				</td>
				<td style="padding: 0.08in;">
					九个月
				</td>
				<td style="padding: 0.08in;">
					十个月
				</td>
				<td style="padding: 0.08in;">
					十一个月
				</td>
				<td style="padding: 0.08in;">
					十二个月
				</td>
			</tr>
			<tr>
				<td style="padding: 0.08in;">
					年费率的百分比
				</td>
				<td style="padding: 0.08in;">
					10
				</td>
				<td style="padding: 0.08in;">
					20
				</td>
				<td style="padding: 0.08in;">
					30
				</td>
				<td style="padding: 0.08in;">
					40
				</td>
				<td style="padding: 0.08in;">
					50
				</td>
				<td style="padding: 0.08in;">
					60
				</td>
				<td style="padding: 0.08in;">
					70
				</td>
				<td style="padding: 0.08in;">
					80
				</td>
				<td style="padding: 0.08in;">
					85
				</td>
				<td style="padding: 0.08in;">
					90
				</td>
				<td style="padding: 0.08in;">
					95
				</td>
				<td style="padding: 0.08in;">
					100
				</td>
			</tr>
		</tbody>
	</table>

	<p class="western" align="right"
		style="letter-spacing: 0.1pt; line-height: 150%; text-indent: 0.25in; margin-left: 0.19in; margin-top: 0in">
		注: 不足一个月的按一个月计收

	</p>
	<p class="western" align="right"
		style="letter-spacing: 0.1pt; line-height: 150%; text-indent: 0.25in; margin-left: 0.19in; margin-top: 0in">
		<br />

	</p>
    </div>

</body>

`
            let wins = window.open("", "print")
            if (!wins) {
                alert("您的浏览器是否拦截了打印的窗口页面,请设置后再重试!")
            } else {
                wins.document.write(pageCont)
            }
        },
    }
}
</script>

<style scoped>
.el-table table {
    width: 100%;
}

.cell button,
.dialog-footer .el-button {
    margin: 0 8px;
}

.search-wrp .el-input {
    width: 60%;
    margin-right: 10px;
}

.el-collapse-item .el-row {
    padding: 6px 12px;
}

.el-pagination {
    margin: 16px auto;
    text-align: center;
}

.el-dialog .el-select {
    width: 100%;
}

.btm-btns {
    margin-top: 25px;
    text-align: center;
}

.el-col {
    padding: 5px;
}

.el-col label {
    line-height: 2.5;
}

.dataFilterWrap .el-row .el-col {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.dataFilterWrap .el-row .el-col label {
    display: block;
    width: 80px;
    padding-right: 2px;
}

.dataFilterWrap button {
    margin-left: 10px;
}

.search-wrp-top .el-col {
    display: flex;
    justify-content: center;
    align-items: center;
}

.order-details .el-input,
.order-details .el-select {
    width: 90%;
}

.order-details button {
    display: block;
    height: 40px;
    width: 90%;
}

.order-details label {
    display: block;
    line-height: 3;
}

.details-btn {
    text-align: center;
    padding-top: 20px;
}
</style>
